<template>
  <div class="antialiased">

    <Sidebar/>


    <div class="page">

      <Header :showSearchField="false" />

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">
                  Tagihan Layanan TWIN
                </h2>
              </div>
            </div>
          </div>

          <ul class="nav nav-tabs">
            <li class="nav-item">
              <router-link class="nav-link active" to="/dashboard/billing/waiting" v-text="'Menunggu Pembayaran'" />
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/dashboard/billing/history" v-text="'Riwayat Tagihan'" />
            </li>
          </ul>

          <div class="mb-4"></div>
          <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>

          <Nodata v-if="!loading && data.length == 0"/>

          <div class="box" v-if="!loading && data.length > 0">
              <div class="card">
                <div class="table-responsive">
                  <table class="table table-vcenter table-hover card-table table-striped table-control">

                    <thead>
                      <tr class="text-muted">
                        <th>No</th>
                        <th>Tertagih</th>
                        <th>Periode</th>
                        <th style="text-align: right">Total</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, i) in data" :key="i">
                        <td>{{row.invoice_no}}</td>
                        <td>{{row.customer_name}}</td>
                        <td>{{row.period}}</td>
                        <td style="text-align: right">
                          {{ribuan(parseInt(row.grand_total) + "|Rp ")}}
                        </td>
                        <td style="text-align: right">
                          <button type="button" class="btn btn-sm btn-primary" @click="_detail(row.id)">Lihat</button>
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
          </div>

          <div class="container-fluid">
            <div class="row justify-content-center">
              <div class="col-12 col-md-auto text-center">
                <button class="btn btn-outline-primary mr-3" @click="() => _pageChange(-1)">
                  Prev
                </button>
                <button class="btn btn-outline-primary" @click="() => _pageChange(+1)">
                  Next
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>


    <div v-if="showDetail">

      <div
          class="modal fade"
          :class="showDetail ? 'show' : ''"
          style="display: block"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
          @click="$event.target.classList.contains('modal') ? _close() : true"
      >
        <div
            class="modal-dialog modal-lg modal-dialog-centered"
            role="document"
            ref="document"
        >

          <div class="modal-content overflow-auto">
            <div class="modal-header">
              <h5 class="modal-title">Detail</h5>
              <button type="button" class="close" @click="_close" v-html="ic('close')"/>
            </div>
            <div class="modal-body pt-3 pb-0" style="min-height: 350px">
              <div v-if="detailLoading">
                Loading...
              </div>
              <div v-else>
                <div class="row mt-2">
                  <div class="col d-flex flex-column">
                    <div><img style="width: 200px;" src="https://stg-twin-kembarputra-com.s3.ap-southeast-3.amazonaws.com/tenant/tenant_jti_1698216955.png" alt="Billing Logo"></div>
                    <div class="col d-flex flex-column mt-1">
                      <span>PT. Jangkar Teknologi Indonesia</span>
                      <span>JL ANGGREK NO.1 KAPAL, MENGWI, KAB. BADUNG BALI</span>
                    </div>
                  </div>
                </div>
  
                <div class="d-flex justify-content-between mt-2" v-if="detail != null">
                  <table>
                    <tbody>
                    <tr>
                      <td style="font-weight: bold">No Invoice</td>
                      <td>: {{detail.invoice_no}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold">Periode</td>
                      <td>: {{detail.period}}</td>
                    </tr>
                    <tr v-if="detail.due_date != null">
                      <td style="font-weight: bold">Jatuh Tempo</td>
                      <td>: {{detail.due_date}}</td>
                    </tr>
                    </tbody>
                  </table>
  
                  <table>
                    <tbody>
                    <tr>
                      <td style="font-weight: bold">Status</td>
                      <td>: <span :class="`badge ${detail.status == 'paid' ? 'bg-success' : ''}`">{{detail.status}}</span></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
  
                <div class="row mt-2">
                  <div class="col d-flex flex-column" v-if="detail != null">
                    <span class="font-weight-bold mt-2">Ditagihkan ke</span>
                    <span>{{detail.customer_name}}</span>
                    <span>{{detail.customer_address}}</span>
                    <span>{{detail.customer_phone}}</span>
                  </div>
                </div>

                <div class="pb-4 mt-2">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>Deskripsi</th>
                      <th>QTY</th>
                      <th style="text-align: right">Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, i) in detail.items" :key="i">
                      <td>
                        <div>{{row.description}}</div>
                        <div>@{{ribuan(parseInt(row.price) + "|Rp ")}}</div>
                      </td>
                      <td>{{ribuan(row.qty)}}</td>
                      <td style="text-align: right">{{ribuan(parseInt(row.sub_total) + "|Rp ")}}</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td style="text-align: right">Sub Total</td>
                      <td style="text-align: right">{{ribuan(parseInt(detail.sub_total) + "|Rp ")}}</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td style="text-align: right">PPN</td>
                      <td style="text-align: right">{{ribuan(parseInt(detail.tax) + "|Rp ")}}</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td style="text-align: right">Grand Total</td>
                      <td style="text-align: right">{{ribuan(parseInt(detail.grand_total) + "|Rp ")}}</td>
                    </tr>
                    </tbody>
                  </table>
                  
                  <div class="form-group" v-if="detail.payment_link == null">
                    <label class="form-label">Metode Pembayaran</label>
                    <div class="selectgroup">
                      <label
                          class="selectgroup-item"
                          v-for="(d, i) in channels"
                          :key="i"
                      >
                        <input
                            type="radio"
                            name="tp"
                            :value="d.payment_method"
                            class="selectgroup-input"
                            v-model="payment_method"
                        />
                        <span
                            class="selectgroup-button"
                        >
                        <img style="height: 50px; width: 100px;" :src="d.payment_image_url" alt="">
                      </span>
                      </label>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <button class="btn btn-primary" @click="_pay">Bayar Sekarang</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import helper from "@/assets/js/helper.js";

export default {
  name: "BillingWaiting",
  data() {
    return {
        auth: {},
        loading: true,
        data: [],
        page: 1,
        next: true,
      showDetail: false,
      detailLoading: false,
      detail: null,
      channels: [],
      payment_method: 'mandiri'
    };
  },

  mixins: [helper],

  methods: {
   _pay() {
      if (this.detail.payment_link == null) {
        this.showDetail = true
        this.detailLoading = true;
        console.log('post')
        this.axios.post(`bills/${this.detail.id}/pay`, {
          payment_method: this.payment_method,
        }).then(res => {
          console.log('posted!')
          const url = res.data.data.data.pay_url;
          this.detail.payment_link = url
          window.open(url, '_blank').focus();
          this.detailLoading = false;
        }).catch( err => {
          this.onError(err)
          this.detailLoading = false;
        });
      } else {
        window.open(this.detail.payment_link, '_blank').focus();
      }
    },
    _close() {
      this.showDetail = false;
      this.detail = null;
    },

    _get(){
      this.loading = true
      this.axios.get(`bills?page=${this.page}`).then(res => {
        this.loading = false;

        if (res.data.data.data.length === 0) {
          this.next = false;
        } else {
          this.data = res.data.data.data;
          this.next = true;
        }
      }).catch( err => {
        this.loading = false;
        this.onError(err)
      });
    },

    _getChannels() {
      this.axios.get(`bills/channels`).then(res => {
        if (res.data.data.length > 0) {
          this.channels = res.data.data;
        }
      }).catch( err => {
        this.onError(err)
      });
    },

    _detail(id) {
      this.showDetail = true
      this.detailLoading = true;
      this.axios.get(`bills/${id}`).then(res => {
        this.detail = res.data.data;

        this.detailLoading = false;
      }).catch( err => {
        this.onError(err)
        this.detailLoading = false;
      });
    },
    _pageChange(page){
      if (page < 0 && this.page === 1) {
        return
      }

      if (page > 0 && !this.next) {
        return
      }

      this.page += page

      this._get()
    },

  },

  mounted(){
    this.auth = JSON.parse(localStorage.user)
    this._get()
    this._getChannels()
  }

};
</script>

<style lang="scss" scoped>
  hr{
    margin: 0 !important
  }
</style>
